import React, { useState } from 'react';
import { AtButton, AtIcon, AtInput } from 'taro-ui';
import { LabelWidget } from "../../index";
const TScanWidget = (props: any) => {
  const { label, value, updateWidgetProperty, inputType, isRequired, regex, onClick, onChange,
    fontSize,
    color,
    fontStyle,
    inputFontSize,
    inputColor,
    inputFontStyle,
    bgColor,
    borderColor,
    readonly,
    isShowInput,
    labelPosition,
    labelAlignment,
    labelWidth,
    placeholder,
    borderBottomColor,
    borderBottomWidth,
    placeholderAlignment
  } = props;
  const [status, setStatus] = useState(false);
  const handleChange = (value: any) => {
    if (value) {
      if (regex) {
        const pattern = new RegExp(`${regex}`);
        setStatus(!pattern.test(value));
      }
    }
    updateWidgetProperty && updateWidgetProperty(value);
    onChange&&onChange();
  };

  // 点击开始扫码 转码时处理
  const onClickScan = () => {
    try {
      if('wx' in window){
        window.wx&&window.wx.scanQRCode({
          desc: 'scanQRCode desc',
          needResult: 1,
          scanType: ["qrCode", "barCode"],
          success: (res:any)=> {
            let resultStr = res.resultStr?.split(',')?.[1];
            updateWidgetProperty && updateWidgetProperty(resultStr);
            onClick&&onClick();
          }
        });
      }
    }catch (e) {

    }

  };

  const scanComponent = () => {
    return <>
      <svg width="28px" onClick={onClickScan} height="28px" viewBox="0 0 42 37" version="1.1" xmlns="http://www.w3.org/2000/svg">
    <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="扫码-(1)" fill-rule="nonzero">
            <path d="M5.39839265,11.2442661 L2,11.2442661 L2,1.69724771 L3.69919633,0 L13.2996556,0 L13.2996556,3.39449541 L5.39839265,3.39449541 L5.39839265,11.2442661 Z M13.2996556,37 L3.69919633,37 L2,35.3027523 L2,25.7557339 L5.39839265,25.7557339 L5.39839265,33.6055046 L13.2996556,33.6055046 L13.2996556,37 Z M39,11.2442661 L35.6016073,11.2442661 L35.6016073,3.39449541 L27.7003444,3.39449541 L27.7003444,0 L37.3008037,0 L39,1.69724771 L39,11.2442661 Z M37.3008037,37 L24.7692308,37 L24.7692308,33.6055046 L35.6016073,33.6055046 L35.6016073,24.6100917 L39,24.6100917 L39,35.3027523 L37.3008037,37 Z" id="形状" fill="#0F0F0F"></path>
            <path d="M12.5661914,11.535545 L15.1323829,11.535545 L15.1323829,15.6303318 L12.5661914,15.6303318 L12.5661914,11.535545 Z M16.287169,21.5592417 L18.8533605,21.5592417 L18.8533605,27.1042654 L16.287169,27.1042654 L16.287169,21.5592417 Z M10,21.5592417 L12.5661914,21.5592417 L12.5661914,26.3364929 L10,26.3364929 L10,21.5592417 Z M22.5743381,21.5592417 L25.1405295,21.5592417 L25.1405295,25.6540284 L22.5743381,25.6540284 L22.5743381,21.5592417 Z M28.4338086,21.5592417 L31,21.5592417 L31,28 L28.4338086,28 L28.4338086,21.5592417 Z M18.8533605,10 L21.4195519,10 L21.4195519,15.6303318 L18.8533605,15.6303318 L18.8533605,10 Z M25.1405295,11.3222749 L27.706721,11.3222749 L27.706721,15.6303318 L25.1405295,15.6303318 L25.1405295,11.3222749 Z" id="形状" fill="#006CF2"></path>
            <polygon id="路径" fill="#006CF2" points="0 17 42 17 42 20 0 20"></polygon>
        </g>
    </g>
    </svg>
    </>
  }

  return (
    <>
      {
        isShowInput?(<LabelWidget
          label={label}
          fontSize={fontSize}
          color={color}
          fontStyle={fontStyle}
          inputFontSize={inputFontSize}
          inputColor={inputColor}
          inputFontStyle={inputFontStyle}
          bgColor={bgColor}
          borderColor={borderColor}
          labelAlignment={labelAlignment}
          labelPosition={labelPosition}
          labelWidth={labelWidth}
          required={isRequired}
          borderBottomColor={borderBottomColor}
          borderBottomWidth={borderBottomWidth}
          placeholderAlignment={placeholderAlignment}
        >
          <div style={{ width: "100%", display: "flex",alignItems:"center",justifyContent:"space-between" }}>
            <AtInput
              editable={!readonly}
              error={status}
              className='at-scan-input'
              name='value'
              type={inputType}
              placeholder={placeholder}
              value={value}
              onChange={handleChange}
            />
            {scanComponent()}
          </div>
        </LabelWidget>):(<>{scanComponent()}</>)
      }
    </>

  );
};

export default TScanWidget;
